namespace GeniuzPOS.Common {
    export namespace DashboardPermissionKeys {
        export const General = "\u0E41\u0E14\u0E0A\u0E1A\u0E2D\u0E23\u0E14:General";
    }
}
